// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"4535":"login","4598":"design","6464":"search","7481":"root","9493":"security","9697":"news"}[chunkId] || chunkId) + "." + {"1767":"410e62f1","4535":"dbbe6423","4598":"3ed67209","5003":"17e46530","6464":"2ac254a0","7481":"70c1ac2b","9493":"6bcc0e08","9697":"10e84289"}[chunkId] + ".css";
};